const ParticipantAws = {
    assign:   (id, faceId) => `participant/${id}/tag/${faceId}`,
    unAssign: (id) => `participant-face/${id}/unassign`,
    undo: (participantGroupId) => `participant-face/${participantGroupId}/undo`
}

export default ParticipantAws